import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const SmartphoneIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg xmlns="http://www.w3.org/2000/svg" width="14.24" height="22.21" viewBox="0 0 14.24 22.21">
        <g data-name="smartphone (4)">
          <path
            data-name="Path 16399"
            d="M24.933 3.008H16.12a2.367 2.367 0 0 0-2.369 2.358V22.16a2.366 2.366 0 0 0 2.369 2.358h8.813a2.361 2.361 0 0 0 2.358-2.358V5.366a2.361 2.361 0 0 0-2.358-2.358zm1.616 19.153a1.618 1.618 0 0 1-1.616 1.616H16.12a1.624 1.624 0 0 1-1.627-1.616V5.366A1.624 1.624 0 0 1 16.12 3.75h8.813a1.618 1.618 0 0 1 1.616 1.616z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth=".7px"
            transform="translate(-13.401 -2.658)"
          />
          <path
            data-name="Path 16400"
            d="M30.289 53.606h-3.155a.371.371 0 1 0 0 .742h3.155a.371.371 0 1 0 0-.742z"
            transform="translate(-21.586 -35.485)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth=".7px"
          />
        </g>
      </svg>
    </SvgIcon>
  );
});
